import { TRACKING_FIELD_NAMES } from '../../constants';
import { ConnectedFormField } from './ConnectedFormField';
import { DescribedCheckbox } from './DescribedCheckbox';
import { FormSection } from './FormSection';
import { useSelector } from 'react-redux';
import { selectUseFilteredTracking } from 'core/userContext';

export const TRACKING_SECTION_TEXT = {
  sectionId: 'tracking',
  sectionHeadingText: 'Tracking',
  trackingFieldNamesDescriptionText:
    'Drop inAppClick events whose associated URL is iterable://dismiss or iterable://delete. Also, drop inAppClose events whose associated URL is not iterable://dismiss.',
  trackingFieldNamesLabelText: 'In-app click and close event tracking',
};

export const TrackingFormSection = () => {
  const useFilteredTracking = useSelector(selectUseFilteredTracking);
  return (
    <>
      {useFilteredTracking && (
        <FormSection
          id={TRACKING_SECTION_TEXT.sectionId}
          data-test={`${TRACKING_SECTION_TEXT.sectionId}-form-section`}
          headingText={TRACKING_SECTION_TEXT.sectionHeadingText}
        >
          <ConnectedFormField name={TRACKING_FIELD_NAMES.USE_FILTERED_TRACKING}>
            <DescribedCheckbox
              data-test={TRACKING_FIELD_NAMES.USE_FILTERED_TRACKING}
              label={TRACKING_SECTION_TEXT.trackingFieldNamesLabelText}
              DescriptionText={TRACKING_SECTION_TEXT.trackingFieldNamesDescriptionText}
              name={TRACKING_FIELD_NAMES.USE_FILTERED_TRACKING}
            />
          </ConnectedFormField>
        </FormSection>
      )}
    </>
  );
};
